import React from 'react'

const PhoneIcon = ({ ...rest }) => {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="22.921"
      height="22.887"
      viewBox="0 0 22.921 22.887"
    >
      <g transform="translate(-370.166 -52.25)">
        <path
          d="M377.135,69.5c5.036,5.036,9.845,6.1,11.621,6.2a13,13,0,0,0,1.937-4.261,16.126,16.126,0,0,0-4.648-3.1l-1.937,1.937a11.592,11.592,0,0,1-4.648-3.1,11.58,11.58,0,0,1-3.1-4.649l1.937-1.937a16.13,16.13,0,0,0-3.1-4.648,12.988,12.988,0,0,0-4.261,1.937C371.034,59.65,372.1,64.46,377.135,69.5Z"
          transform="translate(0 -1.329)"
          fill="none"
          stroke="#22233b"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M392,63a4.383,4.383,0,0,1,4.383,4.383"
          transform="translate(-9.524 -4.522)"
          fill="none"
          stroke="#22233b"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M392,58a7.122,7.122,0,0,1,7.122,7.122"
          transform="translate(-9.524 -2.261)"
          fill="none"
          stroke="#22233b"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M392,53a9.861,9.861,0,0,1,9.861,9.861"
          transform="translate(-9.524)"
          fill="none"
          stroke="#22233b"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  )
}

export { PhoneIcon }
